type GeneratedPanel = {
  dashboards?: unknown[] | null;
};

type UiGenerationAttemptLike = {
  status?: string;
  panels?: GeneratedPanel[] | null;
};

function hasGeneratedDashboards(
  attempt: UiGenerationAttemptLike | null | undefined,
): boolean {
  return (attempt?.panels ?? []).some(
    (panel) => (panel?.dashboards?.length ?? 0) > 0,
  );
}

/**
 * Whether a sync POST /ui/generate response is safe to treat as finished.
 *
 * Reject FAILED always. Accept SUCCESS. The sync path can also return a stale
 * RUNNING/PENDING row that already carries panels — treat that as done so
 * onboarding does not fail when the attempt was not re-read after write.
 */
export function isUiGenerationReady(
  attempt: UiGenerationAttemptLike | null | undefined,
): boolean {
  if (!attempt) return false;
  if (attempt.status === "FAILED") return false;
  if (attempt.status === "SUCCESS") return true;
  // Stale in-flight status on a completed HTTP response: panels mean done.
  if (
    attempt.status === "RUNNING" ||
    attempt.status === "PENDING" ||
    attempt.status == null ||
    attempt.status === ""
  ) {
    return hasGeneratedDashboards(attempt);
  }
  return false;
}

/** @deprecated Prefer isUiGenerationReady; kept as an alias for older call sites. */
export const isUiGenerationSuccess = isUiGenerationReady;
